export default __webpack_public_path__ + "static/media/greenCard.3a3688c5.png";